import { Col, Grid, Row, Typography } from "antd";
import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";

import { Wizard } from "react-use-wizard";
import { getInviteDataFromToken } from "../../networking/pods";
import { InviteData } from "../../redux/reducers/types/commonTypes";
import EmailPassOnboardingStep from "../components/onboarding/EmailPassOnboardingStep";
import PublicInviteTokenBanner from "../components/onboarding/PublicInviteTokenBanner";

const { Title } = Typography;

function useQuery() {
    const { search } = useLocation();

    return React.useMemo(() => new URLSearchParams(search), [search]);
}

export default function Register() {
    const screens = Grid.useBreakpoint();
    const isMobile = !screens.lg;
    const [inviteData, setInviteData] = useState<InviteData>();

    let query = useQuery();
    const inviteToken = query.get("invite_token"); // todo: use this to prefill email and also allow to join to linked policy

    useEffect(() => {
        if (inviteToken) {
            (async () => {
                const response = await getInviteDataFromToken(inviteToken);
                if (response.status === 200) {
                    setInviteData(response.data);
                }
            })();
        }
    }, [inviteToken]);

    return (
        <div style={{ paddingTop: 24, paddingBottom: 24, paddingLeft: isMobile ? 24 : 0, paddingRight: isMobile ? 24 : 0 }}>
            <Row>
                <Col
                    xxl={{ span: 14, offset: 3 }}
                    xl={{ span: 14, offset: 3 }}
                    lg={{ span: 15, offset: 2 }}
                    md={{ span: 20, offset: 2 }}
                    sm={{ span: 24 }}
                    xs={{ span: 24 }}
                >
                    <Title
                        level={2}
                        style={{ textAlign: isMobile ? "center" : "start" }}
                    >
                        Register
                    </Title>
                </Col>
            </Row>
            <Row>
                <Col
                    xxl={{ span: 14, offset: 3 }}
                    xl={{ span: 14, offset: 3 }}
                    lg={{ span: 15, offset: 2 }}
                    md={{ span: 20, offset: 2 }}
                    sm={{ span: 24 }}
                    xs={{ span: 24 }}
                >
                    {inviteData ? (
                        <PublicInviteTokenBanner inviteData={inviteData} />
                    ) : null}
                    <Wizard>
                        <EmailPassOnboardingStep
                            prefilledEmail={inviteData?.email}
                            inviteToken={inviteToken}
                        />
                    </Wizard>
                </Col>
            </Row>
            <Row style={{ marginTop: 16 }}>
                <Col
                    xxl={{ span: 14, offset: 3 }}
                    xl={{ span: 14, offset: 3 }}
                    lg={{ span: 15, offset: 2 }}
                    md={{ span: 20, offset: 2 }}
                    sm={{ span: 24 }}
                    xs={{ span: 24 }}
                >
                    <span>Already have an account?&nbsp;</span>
                    <Link to={"/login"}>
                        <span>Log in</span>
                    </Link>
                </Col>
            </Row>
        </div>
    );
}

